/**
 * The choices offered by SELECT_MODEL_PORTFOLIO_EDIT_TYPE, in branch order.
 *
 * A choice's position here becomes its branch handle id, which is what an admin
 * drags a branch from in the workflow editor and what the step reports back
 * when the user picks it. The order must stay fixed, and must never be derived
 * from which choices are enabled: renumbering would silently repoint branches
 * that have already been drawn.
 */
export const modelPortfolioEditChoices = [
  {
    name: 'editModelPortfolio',
    enableKey: 'enableEditModelPortfolio',
    labelKey: 'editModelPortfolioLabel',
    descriptionKey: 'editModelPortfolioDescription',
  },
  {
    name: 'changeModelPortfolio',
    enableKey: 'enableChangeModelPortfolio',
    labelKey: 'changeModelPortfolioLabel',
    descriptionKey: 'changeModelPortfolioDescription',
  },
  {
    name: 'detachModelPortfolio',
    enableKey: 'enableDetachModelPortfolio',
    labelKey: 'detachModelPortfolioLabel',
    descriptionKey: 'detachModelPortfolioDescription',
  },
  {
    name: 'changeIps',
    enableKey: 'enableChangeIps',
    labelKey: 'changeIpsLabel',
    descriptionKey: 'changeIpsDescription',
  },
] as const;

/**
 * Choices default to enabled, matching the sub-step option defaults, so an
 * unconfigured step still offers all four.
 */
export const isChoiceEnabled = (
  options: Record<string, any> | undefined,
  enableKey: string,
) => options?.[enableKey] !== false;
